/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
// Ember imports
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import MfaFactors from '@linc-technologies/linced-common/enums/mfa-factor';

export default class UserManage extends Component {
  MfaFactors = MfaFactors;

  // Attributes
  // isDialogOpen indicates whether the MFA management dialog is open
  isDialogOpen = false;

  // user is the passed in user object
  user = null;

  // Computed

  // userMethods returns an object of MFA methods categories
  // and an array of method IDs for each category
  @computed('user.mfaFactors.[]')
  get userMethods() {
    let userMethods = {};
    let methodsArray = this.user.get('mfaFactors');

    Object.keys(methodsArray).forEach((key) => {
      let value = methodsArray[key];

      if (!userMethods[value]) {
        // Add the method category if it's not already present
        userMethods[value] = [];
      }

      userMethods[value].push(key);
    });

    return userMethods;
  }

  @action
  toggleDialog() {
    this.toggleProperty('isDialogOpen');
  }
}
